"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicesService = void 0;
class InvoicesService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Return all invoices
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    getInvoices({ customerId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/invoices/{customerId}',
            path: {
                'customerId': customerId,
            },
        });
    }
    /**
     * Retry invoice payment
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    postInvoicesRetry({ invoiceId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/invoices/{invoiceId}/retry',
            path: {
                'invoiceId': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.InvoicesService = InvoicesService;
